/* angular:styles/component:css;ef30ab27be1e6632164cad9a2c77fcf13b852202c9894fbaa69e7b0384bc7514;/home/runner/work/evrideonewuiux/evrideonewuiux/app-client-code/app/js/src/components/clipping-studio/clipping-studio-root/clipping-studio-root.component.ts */
:host {
  display: block;
  width: 100%;
  height: 100vh;
}
/*# sourceMappingURL=clipping-studio-root.component.css.map */
